import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";

import Landing from "./../screen/Landing";
import HomeDetail from "./../screen/HomeDetail";
import Hometype from "./../screen/Hometype";

import siteUrl from "./../shared/siteUrl";

const RoutesApp = () => {
  return (
    //<BrowserRouter>
    <BrowserRouter basename='/theneighbours'>
     <Routes>
      <Route exact path={`${siteUrl}/`} element={<Landing />} />
      <Route exact path={`${siteUrl}/index.html`} element={<Landing />} />
      <Route exact path={`${siteUrl}/hometype/:id`} element={<Hometype />} />
      <Route exact path={`${siteUrl}/single-detached-house/:id"`} element={<HomeDetail />} />
      <Route exact path={`*`} element={<Landing />} />
    </Routes>
    </BrowserRouter>
  );
};

export default RoutesApp;
